import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { units } from '../../utils/spacing';
import { PaletteColor } from '../ThemeProvider';

export const Container = styled.div`
	height: 64px;
	width: 100%;
	position: relative;
	top: 0;
	left: 0;
	z-index: 1000;
	transition: 300ms ease-in-out;
`;

export const UnfilledBarContainer = styled.div`
	display: flex;
	justify-content: end;
`;

export const UnfilledBar = styled.div<{
	percentLeft: number;
}>`
	height: ${units(1)};
	width: ${props => (props.percentLeft === 0 ? units(4) : `${props.percentLeft}%`)};
	margin: ${units(0, 1)};
	position: absolute;
	display: ${props => (props.percentLeft === 0 ? 'none' : 'block')};
	top: 50%;
	border-top-right-radius: ${units(1)};
	border-bottom-right-radius: ${units(1)};
	border-top-left-radius: ${props => (props.percentLeft === 100 ? units(1) : undefined)};
	border-bottom-left-radius: ${props => (props.percentLeft === 100 ? units(1) : undefined)};
	transform: translateY(-50%);
	border-top: 1px solid ${palette('gray3')};
	border-right: 1px solid ${palette('gray3')};
	border-bottom: 1px solid ${palette('gray3')};
	background-color: ${palette('white')};
	z-index: 5;
`;

export const FilledBar = styled.div<{
	filledBackground?: PaletteColor;
}>`
	${props =>
		props.filledBackground
			? css`
					background-color: ${palette(props.filledBackground)};
			  `
			: css`
					background: linear-gradient(
						90.06deg,
						#5c56e6 0.06%,
						#3abbeb 43.17%,
						#bce808 72.88%,
						#ffb800 91.63%,
						#ff5c00 100.52%
					);
			  `}
	position: absolute;
	border-radius: ${units(1)};
	top: 50%;
	z-index: 4;
	height: ${units(1)};
	transform: translateY(-50%);
	width: calc(100% - ${units(1)} * 2);
`;
